import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {decimalInput, fieldError, fieldErrors, InvoicingService} from '../../shared/invoicing.service';
import {CostType} from '../../interfaces/invoicing';

/** The tenant's Kilometers cost type and its default km sales price (#1517), Admin only. */
@Component({
  selector: 'bst-km-cost-type',
  templateUrl: './km-cost-type.component.html',
  styleUrls: ['../invoicing-client/invoicing-form.scss'],
  standalone: false
})
export class KmCostTypeComponent implements OnInit {
  costType: CostType = null;
  errors: Record<string, string[]> = {};
  busy = false;
  private saved: string = null;

  constructor(private invoicing: InvoicingService, private translate: TranslateService) {}

  async ngOnInit() {
    this.costType = await this.invoicing.getKilometers().catch(() => null);
    this.saved = JSON.stringify(this.costType);
  }

  decimal(value: string | null | undefined): string {
    return decimalInput(this.translate, value);
  }

  error(field: string): string | null {
    return fieldError(this.translate, this.errors, field);
  }

  get isDirty(): boolean {
    return !!this.costType && JSON.stringify(this.costType) !== this.saved;
  }

  async save() {
    if (this.busy) { return; }
    this.busy = true;
    this.errors = {};
    const saved = await this.invoicing.saveKilometers(this.costType).catch(e => { this.errors = fieldErrors(e); return null; });
    this.busy = false;
    if (saved) { this.costType = saved; this.saved = JSON.stringify(saved); }
  }
}
